if (!customElements.get('product-description')) {
  customElements.define(
    'product-description',
    class ProductDescription extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('.product__description');
        this.button = this.querySelector('.product__description-toggle');
        if (!this.content || !this.button) return;

        if (this.content.scrollHeight <= this.content.clientHeight + 1) {
          this.button.hidden = true;
          return;
        }

        this.labelMore = this.button.dataset.labelMore;
        this.labelLess = this.button.dataset.labelLess;
        this.button.addEventListener('click', this.toggle.bind(this));
      }

      toggle() {
        const expanded = this.classList.toggle('product__description-wrapper--expanded');
        this.button.setAttribute('aria-expanded', String(expanded));
        this.button.textContent = expanded ? this.labelLess : this.labelMore;
      }
    }
  );
}
